import React, { useState, useEffect } from "react";
import Header from "../Header/Header";
import Select from "react-select";

import { privateRequest } from "../commonApi/CommonApi";
import Swal from "sweetalert2";
import { Image_URL } from "../commonApi/CommonApi";
import { Editor } from "@tinymce/tinymce-react";
import { Helmet } from "react-helmet";
import ReactQuill from "react-quill";
// const BASE_URL = "http://localhost:5500";
// const BASE_URL = "http://52.87.3.228:5500";
function Offers4U() {
  const [selectedFile, setSelectedFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  const [selectedColor, setSelectedColor] = useState("#000000");
  const [getoffers, setGetOffers] = useState([]);
  const [SubHeading, setSubHeading] = useState();
  const [ButtonText, setButtonText] = useState();
  const [ButtonTextColor, setButtonTextColor] = useState("");
  const [ButtonBgColor, setButtonBgColor] = useState();
  const [MainContent, setHeading] = useState("");
  const [OffersBgColor, setBackgroundColor] = useState("#FFFFFF");
  const [status, setStatus] = useState(1);
  const [servicetype, setServicetype] = useState([]);
  const [selectedArea, setSelectedArea] = useState("");
  const [includeArea, setIncludeArea] = useState([]);
  const [excludeArea, setExcludeArea] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedItemId, setSelectedItemId] = useState("");

  const [combineData, setCombineData] = useState([]);
  const [selectedChildCategories, setSelectedChildCategories] = useState([]);
  const [selectedParentCategory, setSelectedParentCategory] = useState();
  const [childCategoryOptions, setChildCategoryOptions] = useState([]);
  const [ServiceTypeOptions, setServiceTypeOptions] = useState([]);
  const [Packageoption, setPackageOption] = useState([]);
  const [serviceOptions, setServiceOptions] = useState([]);
  const [SelectedChildCategory, setSelectedChildCategory] = useState("");
  const [editorData, setEditorData] = useState("");
  const [ServiceGroupOptions, setServiceGroupOptions] = useState([]);
  const [selectedItem, setSelectedItem] = useState({});
  const [serviceValues, setServiceValues] = useState(null);

  const getAllDocumentData = async () => {
    try {
      const response = await privateRequest.get("Service/CombineApis");
      setCombineData(response?.data?.data);
    } catch (error) {
      console.error("Error fetching parent category groups:", error);
    }
  };

  const getServiceArea = async () => {
    try {
      const response = await privateRequest.get("ServiceArea/service");
      setServicetype(response?.data?.Data);
    } catch (error) {
      console.error("Error fetching ServiceArea:", error);
    }
  };

  const getOffers4U = async () => {
    try {
      const response = await privateRequest.get(
        `OffersForYou/OffersForYouByStatus`
      );
      setGetOffers(response?.data?.Data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const DeleteOffers4U = async (_id) => {
    try {
      const result = await Swal.fire({
        title: "Are you sure?",
        text: "You will not be able to recover this item!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#DD6B55",
        confirmButtonText: "Yes, delete it!",
        cancelButtonText: "No, cancel",
        closeOnConfirm: false,
        closeOnCancel: true,
      });

      if (result.isConfirmed) {
        const response = await privateRequest.delete(
          `OffersForYou/DeleteoffersForYou/${_id}`
        );
        getOffers4U();
        Swal.fire("Deleted!", "Your item has been deleted.", "success");
      } else {
        Swal.fire(
          "Cancelled",
          "Your item deletion has been cancelled.",
          "info"
        );
      }
    } catch (error) {
      console.error("DELETE Error:", error);
      Swal.fire("Error!", "Failed to delete item.", "error");
    }
  };

  console.log("selectedItem", selectedItem);

  const AddOffers4U = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      formData.append("SubHeading", SubHeading);
      formData.append("MainContent", editorData);
      formData.append("ButtonText", ButtonText);
      formData.append("ButtonTextColor", ButtonTextColor);
      formData.append("ButtonBgColor", ButtonBgColor);
      formData.append("OffersBgColor", OffersBgColor);
      formData.append("PCatId", selectedParentCategory.value);
      formData.append("CCatId", selectedChildCategories.value);
      formData.append("serviceID", ServiceTypeOptions.value);
      formData.append("OffersStatus", status);

      if (selectedFile) {
        formData.append("OffersImage", selectedFile);
      }
      let response;
      if (selectedItem?._id) {
        // Update existing item
        response = await privateRequest.put(
          `OffersForYou/UpdateOffersForYou/${selectedItem?._id}`,
          formData
        );
      } else {
        // Add new item
        response = await privateRequest.post(
          `OffersForYou/offersForYou`,
          formData
        );
      }

      console.log("POST/PUT Response:", response);
      getOffers4U();

      setShowModal(false);
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: selectedItemId
          ? "Offers4U updated successfully!"
          : "Offers4U added successfully!",
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleEditorChange = (event, editor) => {
    const data = editor.getData();
    setEditorData(data);
  };

  const handleColorChange = (event) => {
    setSelectedColor(event.target.value);
  };

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleParentCategoryChange = (selectedOption) => {
    setSelectedParentCategory({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
    setSelectedChildCategory("");
  };

  const handleChildCategoryChange = (selectedOption) => {
    setSelectedChildCategories({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };

  const handleChangeServices = (selectedOption) => {
    console.log("selecc", selectedOption);
    setServiceTypeOptions({
      value: selectedOption?.value,
      label: selectedOption?.label,
    });
  };

  useEffect(() => {
    getOffers4U();
    getAllDocumentData();
  }, []);

  useEffect(() => {
    const childCategorySelectOptions = combineData?.childCategories
      ?.filter(
        (category) => category.PCName[0] === selectedParentCategory?.value
      )
      ?.map((category) => ({
        value: category._id,
        label: category.CCName,
      }));
    setChildCategoryOptions(childCategorySelectOptions || []);
  }, [selectedParentCategory, combineData?.childCategories]);

  useEffect(() => {
    const serviceGroupSelectOptions = combineData?.serviceGroups
      ?.filter((group) => group.PCName[0] === selectedParentCategory)
      ?.map((group) => ({
        value: group._id,
        label: group.GroupName,
      }));
    setServiceGroupOptions(serviceGroupSelectOptions || []);
  }, [selectedParentCategory, combineData?.serviceGroups]);

  console.log("selectedChildCategories", selectedChildCategories);

  useEffect(() => {
    if (combineData?.newServiceId && combineData?.Package) {
      const selectedServices = combineData.newServiceId
        .filter(
          (service) =>
            service?.ChildCatIDs._id === selectedChildCategories?.value
        )
        .flatMap((service) =>
          service.ServiceVarients.map((varient) => ({
            value: varient?._id,
            label: `${service.ServiceName} (${varient?.ServiceType?.Name !== "NA"
              ? varient?.ServiceType?.Name
              : service?.ChildCatIDs?.CCName
              })`,
            type: "Service",
          }))
        );

      const selectedPackages = combineData.Package.filter((packag) =>
        packag.ChildId.includes(selectedChildCategories?.value)
      ).map((packag) => ({ value: packag._id, label: packag.packageTitle }));

      setServiceOptions([...selectedServices, ...selectedPackages]);
    } else {
      setServiceOptions([]);
    }
  }, [selectedChildCategories, combineData]);

  useEffect(() => {
    if (
      selectedItem &&
      selectedChildCategories.value &&
      serviceOptions.length > 0
    ) {
      const id = serviceOptions?.filter(
        (serviceItem) => serviceItem.value === selectedItem?.serviceID
      );

      if (id && id.length > 0) {
        const values = {
          value: selectedItem?.serviceID || "",
          label: id[0]?.ServiceName || "",
          type: "Service",
        };

        console.log("values", values);
        console.log("id", id);
        setServiceTypeOptions(id[0]);
        setServiceValues(values); // Set the service values state
      }
    }
  }, [selectedChildCategories, selectedItem, serviceOptions]);
  console.log("serviceValues", status);

  const handleEditButtonClick = (event, item) => {
    setSelectedItem(item);

    setSelectedChildCategories({
      label: item?.CCatId?.CCName,
      value: item?.CCatId?._id,
    });
    setEditorData(item.MainContent);
    setButtonTextColor(item.ButtonTextColor);
    setButtonBgColor(item.ButtonBgColor);
    setBackgroundColor(item.OffersBgColor);
    setStatus(item.OffersStatus);
    setButtonText(item.ButtonText);
    setSelectedFile(item.OffersImage);
    setSelectedFile(null);
    setStatus(item.OffersStatus == true ? 1 : 0);
    setImagePreview(Image_URL + item.OffersImage);
    setSelectedFile(item.OffersImage);
    setSubHeading(item.SubHeading);

    setShowModal(true);
  };

  useEffect(() => {
    if (combineData?.parentCategories && selectedItem) {
      setSelectedParentCategory({
        value:
          combineData?.parentCategories?.find(
            (category) => category._id === selectedItem?.PCatId?._id
          )?._id || "",
        label:
          combineData?.parentCategories?.find(
            (category) => category._id === selectedItem?.PCatId?._id
          )?.PCName || "",
      });
    }
  }, [combineData, selectedItem]);

  console.log("selected parent categry", selectedParentCategory);
  console.log("selectedItem", selectedItem);
  console.log("ServiceTypeOptions", ServiceTypeOptions);

  return (
    <>
      {getoffers.length > 0 && (
        <Helmet>
          <script>new DataTable("#my_table");</script>
        </Helmet>
      )}
      <div className="app-main">
        <div className="wrapper">
          <div className="page">
            <div className="page-inner">
              <div className="container-fluid">
                <header className="page-title-bar">
                  <div className="d-flex flex-column flex-md-row">
                    <p className="lead mb-0">
                      <span className="font-weight-bold">Offers4U</span>
                    </p>
                    <button
                      className="btn btn-primary btn-sm ml-auto"
                      // data-toggle="modal"
                      // data-target="#addHeroSliderModal"
                      onClick={() => {
                        setShowModal(true);

                        setSelectedParentCategory(null);
                        setSelectedChildCategories([]);
                        setImagePreview("");
                        setEditorData("");
                        setButtonTextColor("");
                        setButtonBgColor("");
                        setBackgroundColor("");
                        setStatus("");
                        setButtonText("");
                        setSelectedFile("");
                        setSelectedFile("");
                        setStatus("");
                        setSelectedItemId("");
                        setServiceTypeOptions("");
                        setSelectedFile("");
                        setSubHeading("");
                      }}
                    >
                      <i className="fa fa-plus mr-2"></i>Add New
                    </button>
                  </div>
                </header>
                <div className="page-section">
                  <div className="card">
                    <div className="card-body table-responsive">
                      <table
                        id="my_table"
                        className="table table-striped table-hover table-sm no-footer"
                      >
                        <thead className="bg-primary text-white">
                          <tr>
                            <th scope="col">Sr No</th>
                            <th scope="col">ParentId</th>
                            <th scope="col">ChildId</th>
                            <th scope="col">Offers4U</th>
                            <th scope="col">Status</th>
                            <th scope="col">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {getoffers.map((item, index) => (
                            <tr key={index}>
                              <td className="align-center">{index + 1}</td>
                              <td className="align-center">
                                {item?.PCatId?.PCName}
                              </td>
                              <td className="align-center">
                                {item?.CCatId?.CCName}
                              </td>

                              <td className="align-center">
                                <div
                                  className="card"
                                  style={{
                                    background: item.OffersBgColor,
                                    width: "300px",
                                  }}
                                >
                                  <div className="card-body py-2 px-2">
                                    <div
                                      style={{
                                        display: "flex",
                                        justifyContent: "space-between",
                                      }}
                                    >
                                      <div>
                                        <div
                                          style={{
                                            textAlign: "left",
                                            width: "120px",
                                          }}
                                        >
                                          <span
                                            className="d-block"
                                            style={{
                                              color: "red",
                                              fontSize: "13px",
                                              marginBottom: "5px",
                                            }}
                                          >
                                            <td
                                              className="align-center"
                                              dangerouslySetInnerHTML={{
                                                __html: item.MainContent,
                                              }}
                                            ></td>
                                          </span>
                                          <span
                                            className="d-block"
                                            style={{
                                              color: "red",
                                              fontSize: "12px",
                                              fontWeight: 600,
                                            }}
                                          >
                                            {item.SubHeading}
                                          </span>
                                          {/* <span
                                          className="d-block"
                                          style={{
                                            color: "red",
                                            fontSize: "12px",
                                            fontWeight: 600,
                                          }}
                                        >
                                          Face Bleach
                                        </span> */}
                                        </div>
                                        <div style={{ textAlign: "left" }}>
                                          <span
                                            className="p-2 mt-2 d-block"
                                            style={{
                                              width: "80px",
                                              background: item.ButtonBgColor,

                                              color: item.ButtonTextColor,
                                              fontSize: "10px",
                                              textAlign: "center",
                                              borderRadius: "15px",
                                            }}
                                          >
                                            {item.ButtonText}
                                          </span>
                                        </div>
                                      </div>
                                      <div>
                                        {item.OffersImage && (
                                          <img 
                                            src={`${Image_URL}${item.OffersImage}`}
                                            alt="Slider Image"
                                            height="100"
                                            width="100"
                                          />
                                        )}
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </td>

                              <td>
                                {" "}
                                <span
                                  className={`badge ${item.OffersStatus
                                    ? "badge-primary"
                                    : "badge-danger"
                                    }`}
                                >
                                  {item.OffersStatus ? "Active" : "Inactive"}
                                </span>
                              </td>
                              <td className="align-center">
                                <div className="btn-group">
                                  <button
                                    className="btn btn-primary btn-sm"
                                    // onClick={() => {
                                    //   console.log("consoleItem", item);
                                    //   setSelectedItemId(item._id);
                                    //   setSubHeading(item.SubHeading);
                                    //   setSelectedParentCategory({
                                    //     value:
                                    //       combineData?.parentCategories?.find(
                                    //         (category) =>
                                    //           category._id === item?.PCatId?._id
                                    //       )?._id,
                                    //     label:
                                    //       combineData?.parentCategories?.find(
                                    //         (category) =>
                                    //           category._id === item?.PCatId?._id
                                    //       )?.PCName,
                                    //   });

                                    //   setSelectedChildCategories({
                                    //     label: item?.CCatId?.CCName,
                                    //     value: item?.CCatId?._id,
                                    //   });
                                    //   handleChangeServices({
                                    //     value: item?.serviceID,
                                    //     label: combineData?.newServiceId?.find(
                                    //       (category) =>
                                    //         category._id == item.serviceID
                                    //     )?.ServiceName,
                                    //   });

                                    //   setEditorData(item.MainContent);
                                    //   setButtonTextColor(item.ButtonTextColor);
                                    //   setButtonBgColor(item.ButtonBgColor);
                                    //   setBackgroundColor(item.OffersBgColor);
                                    //   setStatus(item.OffersStatus);
                                    //   setButtonText(item.ButtonText);
                                    //   setSelectedFile(item.OffersImage);
                                    //   setShowModal(true);
                                    // }}
                                    onClick={(event) => {
                                      handleEditButtonClick(event, item);
                                    }}
                                  >
                                    <i className="fa fa-edit"></i>
                                  </button>
                                  <button
                                    className="btn btn-danger btn-sm"
                                    onClick={() => DeleteOffers4U(item._id)}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* All Modals */}
      <div
        className={`modal fade ${showModal ? "show" : ""}`}
        // id="addAreaModal"
        role="dialog"
        style={{ display: showModal ? "block" : "none" }}
      >
        <div
          className="modal-dialog  modal-dialog-centered modal-lg "
          role="document"
          style={{ maxHeight: "80vh", overflowY: "auto" }}
        >
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="exampleModalLongTitle">
                Offers4U
              </h5>
              <button
                type="button"
                className="close"
                onClick={() => setShowModal(false)}
                aria-label="Close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div
              className="modal-body"
              style={{
                overflow: "scroll",
              }}
            >
              <form style={{ paddingTop: "20px" }} onSubmit={AddOffers4U}>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Parent Category</label>
                      <Select
                        isClearable
                        label={selectedParentCategory}
                        value={selectedParentCategory}
                        onChange={handleParentCategoryChange}
                        options={
                          combineData?.parentCategories?.map((category) => ({
                            value: category._id,
                            label: category.PCName,
                          })) || []
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>Child Category</label>
                      <Select
                        isClearable
                        value={selectedChildCategories}
                        label={selectedChildCategories}
                        onChange={handleChildCategoryChange}
                        options={childCategoryOptions}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label>ItemId</label>
                      <Select
                        isClearable
                        value={ServiceTypeOptions}
                        label={ServiceTypeOptions}
                        options={serviceOptions}
                        onChange={(selectedOptions) =>
                          handleChangeServices(selectedOptions)
                        }
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="mb-0">Sub Heading</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Sub Heading"
                        value={SubHeading}
                        onChange={(e) => setSubHeading(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="mb-0">Heading</label>
                      <ReactQuill
                        className="h-100"
                        modules={{
                          toolbar: [
                            [{ header: [1, 2, false] }],
                            [
                              "bold",
                              "italic",
                              "underline",
                              "strike",
                              "blockquote",
                            ],
                            [
                              { list: "ordered" },
                              { list: "bullet" },
                              { indent: "-1" },
                              { indent: "+1" },
                            ],
                            ["link", "image"],
                            ["clean"],
                          ],
                        }}
                        theme="snow"
                        formats={[
                          "header",
                          "bold",
                          "italic",
                          "underline",
                          "strike",
                          "blockquote",
                          "list",
                          "bullet",
                          "indent",
                          "link",
                          "image",
                        ]}
                        value={editorData}
                        onChange={setEditorData}
                      />
                    </div>
                  </div>
                  <div className="col-lg-12">
                    <div className="form-group">
                      <label className="mb-0">Background Color</label>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={OffersBgColor}
                          onChange={(e) => setBackgroundColor(e.target.value)}
                          style={{ width: "100px" }}
                        />
                        <input
                          type="color"
                          className="form-control"
                          value={OffersBgColor}
                          onChange={(e) => setBackgroundColor(e.target.value)}
                          style={{ width: "100px" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Button Text</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Button Text"
                        value={ButtonText}
                        onChange={(e) => setButtonText(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Button Color</label>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={ButtonBgColor}
                          onChange={(e) => setButtonBgColor(e.target.value)}
                          style={{ width: "100px" }}
                        />

                        <input
                          type="color"
                          className="form-control"
                          value={ButtonBgColor}
                          onChange={(e) => setButtonBgColor(e.target.value)}
                          style={{ width: "100px" }}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Button Text Color</label>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="text"
                          className="form-control"
                          value={ButtonTextColor}
                          onChange={(e) => setButtonTextColor(e.target.value)}
                          style={{ width: "100px" }}
                        />
                        <input
                          type="color"
                          className="form-control"
                          value={ButtonTextColor}
                          onChange={(e) => setButtonTextColor(e.target.value)}
                          style={{ width: "100px" }}
                        />
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Image</label>
                      <input
                        type="file"
                        className="form-control"
                        accept="image/*"
                        onChange={handleFileInputChange}
                      />
                    </div>
                  </div>
                  {imagePreview && (
                    <div className="col-lg-4">
                      <img
                        width="80"
                        height="50"
                        src={imagePreview}
                        alt="Preview"
                        style={{ maxWidth: "100%" }}
                      />
                    </div>
                  )}
                  <div className="col-lg-4">
                    <div className="form-group">
                      <label className="mb-0">Status</label>
                      <select
                        className="form-control"
                        value={status}
                        onChange={(e) => setStatus(e.target.value)}
                      >
                        <option value="">Select</option>
                        <option value="1">Active</option>
                        <option value="0">Inactive</option>
                      </select>
                    </div>
                  </div>
                </div>
                <hr className="mt-0" />

                <div className="row">
                  <div className="col-lg-12">
                    <div className="form-group text-left">
                      <button type="submit" className="btn btn-primary">
                        Submit
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      {showModal && <div className="modal-backdrop fade show"></div>}
    </>
  );
}

export default Offers4U;
